import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AuthCallback from "./components/AuthCallback";
import RequireAccount from "./components/RequireAccount";
import Home from "./pages/Home";
import Game from "./pages/Game";
import Multiplayer from "./pages/Multiplayer";
import MatchPlay from "./pages/MatchPlay";
import PepMatch from "./pages/PepMatch";
import AdminStats from "./pages/AdminStats";
import PenaltyLobby from "./pages/PenaltyLobby";
import PenaltyMatch from "./pages/PenaltyMatch";
import DevAccountSwitcher from "./components/DevAccountSwitcher";
import DailyClash from "./pages/DailyClash";
import Friends from "./pages/Friends";
import { NotificationsPoller } from "./components/Notifications";
import CookieConsent from "./components/CookieConsent";
import Legal from "./pages/Legal";
import RegisterInterest from "./pages/RegisterInterest";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/game" element={<RequireAccount><Game /></RequireAccount>} />
      <Route path="/multiplayer" element={<RequireAccount><Multiplayer /></RequireAccount>} />
      <Route path="/multiplayer/match/:id" element={<RequireAccount><MatchPlay /></RequireAccount>} />
      <Route path="/w/:id" element={<RequireAccount><MatchPlay /></RequireAccount>} />
      <Route path="/penalties" element={<RequireAccount><PenaltyLobby /></RequireAccount>} />
      <Route path="/p/:id" element={<RequireAccount><PenaltyMatch /></RequireAccount>} />
      <Route path="/pep" element={<RequireAccount><PepMatch /></RequireAccount>} />
      <Route path="/friends" element={<RequireAccount><Friends /></RequireAccount>} />
      <Route path="/daily" element={<RequireAccount><DailyClash /></RequireAccount>} />
      <Route path="/admin" element={<AdminStats />} />
      <Route path="/register" element={<RegisterInterest />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/cookies" element={<Legal doc="cookies" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <DevAccountSwitcher />
        <NotificationsPoller />
        <AppRoutes />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
